var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"inline-flex shrink-0 items-center justify-center transition-all",class:[
    _setup.sizeClasses,
    _setup.shapeClasses,
    _setup.variantClasses,
    _vm.disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
  ],attrs:{"type":"button","disabled":_vm.disabled,"aria-label":_vm.ariaLabel,"data-size":_setup.actualSize,"data-variant":_setup.actualVariant,"data-shape":_setup.actualShape},on:{"click":function($event){return _setup.emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }